import Organisation from '@/components/localdestinations/list-item-organisation.vue';
import Skihall from '@/components/localdestinations/list-item-skihall.vue';
import Dryslope from '@/components/localdestinations/list-item-dryslope.vue';
import Revolvingslope from '@/components/localdestinations/list-item-revolvingslope.vue';
import ListItemTitle from '@/components/localdestinations/list-item-title.vue';

export default {
	functional: true,

	render(createElement, context) {
		context.data.props = {
			address_string: [
				context.props.address.street,
				context.props.address.postcode,
				context.props.address.city,
				context.props.address.country
			]
				.filter(e => !!e)
				.join(', ')
		};

		if (context.props.affiliateUrl && process.client) {
			context.data.props.affiliateLink = `${
				window.location.origin
			}/redir?u=${encodeURIComponent(context.props.affiliateUrl)}&i=${
				context.props.id
			}&t=localdestination&h=${context.parent.$redirHash(
				context.props.affiliateUrl
			)}`;
		}

		context.data.scopedSlots = {
			title() {
				return createElement(ListItemTitle, context.data);
			}
		};

		switch (context.props.type) {
			case 'skihall':
				return createElement(Skihall, context.data, context.children);
			case 'dryslope':
				return createElement(Dryslope, context.data, context.children);
			case 'revolvingslope':
				return createElement(Revolvingslope, context.data, context.children);
			case 'organisation':
			default:
				return createElement(Organisation, context.data, context.children);
		}
	}
};
